import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { Button } from 'foundations-components/transitional/components/Button';
import { ACRouterButton } from 'academy-common-lib/components/ACRouterButton';
import { LearningContentCard } from 'academy-common-lib/features/learningContentCard/components/LearningContentCard';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useAnnouncements } from '../hooks/AnnouncementsSectionHooks';
import HomePageSection from '../../../components/Layouts/HomePageSection';
import SimpleCarousel from '../../../components/SimpleCarousel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getInternalPath = url => {
  if (url.startsWith('/')) {
    return url;
  }
  const academyUrlMatch = url.match(/^https?:\/\/(app|local)(-[a-z0-9]+)?\.hubspot(qa)?\.com\/academy\/[^/]+(.*)$/);
  if (academyUrlMatch) {
    return academyUrlMatch[4] || '/';
  }
  return undefined;
};
export const AnnouncementsSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    announcements,
    loading,
    error,
    featuredCardModels
  } = useAnnouncements();
  if (loading || error || announcements.length === 0) {
    return null;
  }
  const featuredAnnouncement = announcements[0];
  const internalPath = getInternalPath(featuredAnnouncement.ctaUrl || '');
  const cardContent = /*#__PURE__*/_jsx(CardWrapper, {
    borderRadius: "300",
    "data-test-id": "announcements-section",
    marginBlockEnd: "0",
    padding: isMobile ? '600' : '1000',
    paddingBlock: isMobile ? '500' : '1000',
    children: /*#__PURE__*/_jsxs(CardGrid, {
      alignItems: "stretch",
      gap: "900",
      gridTemplateColumns: isMobile ? '1fr' : featuredCardModels && featuredCardModels.length > 1 ? '8fr 4fr' : '9fr 3fr',
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        blockSize: "100%",
        flexDirection: "column",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          marginBlockEnd: "200",
          typography: "heading-300",
          children: featuredAnnouncement.title
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "600",
          typography: "body-200",
          children: featuredAnnouncement.body
        }), featuredAnnouncement.ctaUrl && /*#__PURE__*/_jsx(_Fragment, {
          children: internalPath ? /*#__PURE__*/_jsx(ACRouterButton, {
            onClick: () => {
              // TO-DO: Add event tracking for CTA
            },
            to: internalPath,
            use: "secondary",
            children: featuredAnnouncement.ctaText || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.announcements.showMore"
            })
          }) : /*#__PURE__*/_jsx(Button, {
            external: true,
            href: featuredAnnouncement.ctaUrl || '#',
            use: "secondary",
            children: featuredAnnouncement.ctaText || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.announcements.showMore"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(View, {
        children: featuredCardModels ? !isMobile ? /*#__PURE__*/_jsx(SimpleCarousel, {
          isMobile: isMobile,
          children: featuredCardModels.map(cardModel => /*#__PURE__*/_jsx(LearningContentCard, {
            item: cardModel,
            size: isMobile ? 'small' : 'large'
          }, cardModel.id))
        }) : /*#__PURE__*/_jsx(Flex, {
          display: "flex",
          flexDirection: "column",
          gap: "200",
          marginBlockEnd: "200",
          children: featuredCardModels.map(cardModel => /*#__PURE__*/_jsx(LearningContentCard, {
            item: cardModel,
            size: isMobile ? 'small' : 'large'
          }, cardModel.id))
        }) : /*#__PURE__*/_jsx(Image, {
          alt: I18n.text('learningCenter.announcements.altText'),
          blockSize: "auto",
          inlineSize: "100%",
          objectFit: "contain",
          src: featuredAnnouncement.banner || ''
        })
      })]
    })
  });
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "HOMEPAGE_ANNOUNCEMENTS_LOADED",
    children: /*#__PURE__*/_jsx(HomePageSection, {
      marginBlock: isMobile ? '500' : '1000',
      paddingBlock: "0",
      children: cardContent
    })
  });
};
export default AnnouncementsSection;